import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { MobileTabBar } from "@/components/MobileTabBar";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AtikxzioRedirect from "@/pages/AtikxzioRedirect";
import Pricing from "@/pages/Pricing";
import ProductCMH from "@/pages/ProductCMH";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Navbar />
            <main>
              <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products/atikxzio-cmh" element={<ProductCMH />} />
                  <Route path="/products/atikxzio-hms" element={<AtikxzioRedirect />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/careers" element={<Careers />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/shipping-policy" element={<ShippingPolicy />} />
                </Routes>
            </main>
            <Footer />
          </SmoothScroll>
          <WhatsAppFloat />
          <MobileTabBar />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
